var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/popupClose.3fa90aef.png","uri@2x": __webpack_public_path__ + "static/media/popupClose.a1c4c4aa.png","uri@3x": __webpack_public_path__ + "static/media/popupClose.9c438931.png",
    width: 32,
    height: 32
});